let timeout = null;

const debounce = (callback, wait) => {
  if (timeout) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(callback, wait);
};

export default debounce;



// WEBPACK FOOTER //
// ./src/helpers/timers/debounce.js